import { Container } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import GioSach from 'src/sections/gio-sach/gio-sach';

export default function Page() {
  return (
    <>
      <Helmet>
        <title> Giỏ sách </title>
      </Helmet>

      <Container>
        <GioSach />
      </Container>
    </>
  );
}
